export const DOCUMENTS_UPLOAD_API_REQUEST = 'DOCUMENTS_UPLOAD_API_REQUEST';
export const DOCUMENTS_UPLOAD_API_ERROR = 'DOCUMENTS_UPLOAD_API_ERROR';
export const DOCUMENTS_UPLOAD_API_SUCCESS = 'DOCUMENTS_UPLOAD_API_SUCCESS';
